import { EApplicationUrls } from 'data/urls/application.url';
import {
  TApplicationProfile,
  TApplicationProfileUI,
} from 'data/types/Tenant.types';
import { applicationProfileConvertor } from 'data/convertors/Tenant.convertors';
import { authSplitApi } from '../helpers/slice.helpers';
import {
  TVetRecordDocumentsUI,
  TVetRecordTypeNameUpdateUI,
  TVetRecordUI,
} from '../../data/types/Animal.types';
import { EAnimalUrls } from '../../data/urls/animal.url';
import {
  deleteVetRecordConvertor,
  updateVetRecordDocumentsConvertor,
  vetRecordTypeUpdateConverter,
} from '../../data/convertors/Animal.converters';
import {
  // TSADocPacketCreateUI,
  TSALetterUpdateUI,
} from '../../data/types/AnimalTraining.types';
import { EAnimalTrainingUrls } from '../../data/urls/animalTraining.url';
import {
  // createSADocPacketsConvertor,
  saLetterUpdateConvertor,
} from '../../data/convertors/AnimalTraining.convertors';

export const applicationApi = authSplitApi('applicationReducer', [
  'applicationList',
  'application',
  'applicationAnimal',
  'applicationProfile',
]).injectEndpoints({
  endpoints: build => ({
    updateVetRecordDocuments: build.mutation<void, TVetRecordDocumentsUI>({
      query(body) {
        return {
          url: `${EAnimalUrls.ANIMAL}/vet-records`,
          method: 'PUT',
          body: updateVetRecordDocumentsConvertor.toDb(body),
        };
      },
      invalidatesTags: ['vetRecords', 'animal', 'applicationAnimal'],
    }),
    deleteVetRecord: build.mutation<void, TVetRecordUI>({
      query(body) {
        return {
          url: `${EAnimalUrls.ANIMAL}/vetRecords`,
          method: 'DELETE',
          body: deleteVetRecordConvertor.toDb(body),
        };
      },
      invalidatesTags: ['vetRecords', 'animal', 'applicationAnimal'],
    }),
    updateVetRecordType: build.mutation<void, TVetRecordTypeNameUpdateUI>({
      query(body) {
        return {
          url: `${EAnimalUrls.ANIMALS}/${EAnimalUrls.VET_RECORDS}/${EAnimalUrls.TYPE}`,
          method: 'PATCH',
          body: vetRecordTypeUpdateConverter.toDb(body),
        };
      },
      invalidatesTags: ['vetRecords', 'animal', 'applicationAnimal'],
    }),
    updateSALetters: build.mutation<void, TSALetterUpdateUI>({
      query(data) {
        return {
          url: `${EAnimalTrainingUrls.SA_LETTERS}`,
          method: 'PATCH',
          body: saLetterUpdateConvertor.toDb(data),
        };
      },
      invalidatesTags: ['applicationAnimal'],
    }),
    // createSADocPacket: build.mutation<void, TSADocPacketCreateUI>({
    //   query(body) {
    //     return {
    //       url: '',
    //       method: 'POST',
    //       body: createSADocPacketsConvertor.toDb(body),
    //     };
    //   },
    //   invalidatesTags: ['applicationAnimal'],
    // }),
    getApplicationProfile: build.query<
      TApplicationProfileUI,
      { applicationId?: string }
    >({
      query({ applicationId }) {
        return {
          url: `${EApplicationUrls.APPLICATION}/${EApplicationUrls.STEP}/${EApplicationUrls.TENANT}`,
          method: 'GET',
          params: { applicationId },
        };
      },
      transformResponse: (data: TApplicationProfile) =>
        applicationProfileConvertor.fromDb(data),
      providesTags: ['applicationProfile'],
    }),
  }),

  overrideExisting: false,
});

export const {
  // useCreateSADocPacketMutation,
  useUpdateSALettersMutation,
  useUpdateVetRecordTypeMutation,
  useUpdateVetRecordDocumentsMutation,
  useDeleteVetRecordMutation,
  useGetApplicationProfileQuery,
} = applicationApi;
